module.exports = __webpack_public_path__ + "static/media/GLORY_6721.3a2fae63.jpg";